<template>
    <div>
        <div :class="$style.legend">
            <div>
                <div :class="$style.item">
                    <div
                        :class="[
                            $style.changeRequestNotReceived,
                            $style.colorBox,
                        ]"
                    />
                    <span>Change Request pending</span>
                    <div :class="[$style.willCall, $style.colorBox, 'ml-4']" />
                    <span>Will Call</span>
                </div>
            </div>
        </div>
        <el-table
            id="DeliveryRequestTable"
            style="width: 100%"
            max-height="700"
            :data="scheduledDeliveries"
            :row-class-name="tableRowClassName"
            @row-click="$emit('rowClicked', $event)"
        >
            <el-table-column
                v-for="column in tableColumns"
                :key="column.label"
                :width="column.width"
                :min-width="column.minWidth"
                :prop="column.prop"
                :label="column.label"
                :sortable="column.sortable"
                :formatter="column.formatter"
                :sort-method="column.sortMethod"
                :show-overflow-tooltip="true"
            >
                <template slot="header" slot-scope="scope">
                    {{ scope.column.label }}
                </template>
                <template slot-scope="props">
                    <template v-if="props.column.property === 'status'">
                        <div :class="getStyleForStatus(props.row.status)">
                            {{ props.row.status }}
                        </div>
                    </template>
                    <template v-else-if="props.column.formatter">
                        {{ props.column.formatter(props.row) }}
                    </template>
                    <template v-else>
                        {{ getProp(props.row, props.column.property) }}
                    </template>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>
<script>
import { DatePicker } from "element-ui";

import moment from "moment-timezone";
import _ from "lodash";

export default {
    name: "DeliveryRequestsTable",
    components: {
        [DatePicker.name]: DatePicker,
    },
    props: {
        scheduledDeliveries: {
            type: Array,
            required: true,
        },
        excludeColumns: {
            type: Array,
            default: () => [],
        },
    },
    computed: {
        tableColumns() {
            let columns = [
                {
                    prop: "id",
                    label: "ID",
                    sortable: true,
                    width: 100,
                },
                {
                    prop: "receipt_log_ids",
                    label: "Receipt Logs",
                    width: 180,
                },
                {
                    prop: "status",
                    label: "Status",
                    sortable: true,
                    width: 150,
                },
                {
                    prop: "customer_name",
                    label: "Customer",
                    width: 250,
                },
                {
                    prop: "designer_names",
                    label: "Designers",
                    width: 150,
                },
                {
                    prop: "location",
                    label: "Location",
                    width: 200,
                },
                {
                    prop: "delivery_city",
                    label: "City",
                    sortable: true,
                    width: 150,
                },
                {
                    prop: "delivery_date",
                    label: "Time",
                    sortable: true,
                    sortMethod: (a, b) =>
                        new Date(b.delivery_date) - new Date(a.delivery_date),
                    formatter: (row) => this.deliveryDateWithTime(row),
                    width: 250,
                },
                {
                    prop: "estimated_cubes",
                    label: "Est. Cubes",
                    width: 100,
                },
                {
                    prop: "created_at",
                    label: "Submitted",
                    formatter: (row) =>
                        `${this.formatDateTime(row.created_at)} by ${row.created_by}`,
                    sortable: true,
                    sortMethod: (a, b) =>
                        new Date(b.created_at) - new Date(a.created_at),
                    width: 300,
                },
                {
                    prop: "updated_at",
                    label: "Updated",
                    formatter: (row) => this.updatedRowInfo(row),
                    sortable: true,
                    sortMethod: (a, b) =>
                        new Date(b.created_at) - new Date(a.created_at),
                    width: 300,
                },
            ];
            columns = columns.filter(
                (column) =>
                    this.excludeColumns.findIndex(
                        (hide) => hide === column.label,
                    ) === -1,
            );
            return columns;
        },
        deliveryWindow: {
            get() {
                return this.selectedDeliveryWindow;
            },
            set(window) {
                this.selectedDeliveryWindow = window;
                this.deliveryChange.deliveryWindow = window.value;
            },
        },
    },
    methods: {
        formatDate(date) {
            if (date) {
                return moment(date).format("MM/DD/YYYY");
            }
            return "--";
        },
        updatedRowInfo(row) {
            if (row.updated_by) {
                return `${this.formatDateTime(row.updated_at)} by ${row.updated_by}`;
            }
            return "--";
        },
        getProp(object, property) {
            return _.get(object, property);
        },
        getStyleForStatus(status) {
            return [status.toLowerCase(), "statusLabel"];
        },
        formatDateTime(date) {
            if (date) {
                return moment(date).format("MM/DD/YYYY - h:mm A ");
            }
            return "--";
        },
        deliveryDateWithTime(item) {
            let time = item.delivery_window;
            if (time === "Morning") time = "9AM - 11AM";
            if (time === "Midday") time = "11AM - 1PM";
            if (time === "Afternoon") time = "1PM - 3PM";
            if (time === "Any") time = "9AM - 3PM";
            return `${this.formatDate(item.delivery_date)} ${time}`;
        },
        tableRowClassName({ row }) {
            const classNames = [];
            if (row.will_call) {
                classNames.push(this.$style.willCall);
            }
            if (row.change_request_received === false) {
                classNames.push(this.$style.changeRequestNotReceived);
            }
            return classNames;
        },
    },
};
</script>

<style module>
.willCall {
    background-color: rgba(0, 183, 255, 0.3) !important;
}
.changeRequestNotReceived {
    background-color: rgba(255, 255, 0, 0.3) !important;
}
.legend {
    display: flex;
}
.item {
    display: flex;
    padding-right: 20px;
}
.colorBox {
    width: 20px;
    height: 20px;
    display: inline-flex;
    margin-right: 10px;
    border: 1px solid gray;
}
</style>
